import { render, staticRenderFns } from "./categoryManager.vue?vue&type=template&id=76cab61c&"
import script from "./categoryManager.vue?vue&type=script&lang=js&"
export * from "./categoryManager.vue?vue&type=script&lang=js&"
import style0 from "./categoryManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports